const companyBankAccounts = state => state.companyBankAccounts
const isSendFormCompanyBankAccount = state => state.isSendFormCompanyBankAccount
const hasError = state => state.error !== null
const error = state => state.error
const isLoading = state => state.isLoading
const hasCompanyBankAccounts = state => state.companyBankAccounts.length > 0
const companyBankAccount = state => state.companyBankAccount

export default {
  companyBankAccount,
  isSendFormCompanyBankAccount,
  hasCompanyBankAccounts,
  companyBankAccounts,
  hasError,
  error,
  isLoading,
}
